import * as React from "react";
import { MainLayout } from "../Components/MainLayout";
import { Link, useLocation } from "react-router-dom";
import { PersonalInformation } from "../Components/Stepper/PersonalInformation";
import { DiscountBox } from "../Components/DiscountBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Helmet from "../Components/Helment";

const Profile = () => {
  const location = useLocation();
  return (
   
      <div className="mt-2">
        <DiscountBox />
        <div className="card wd-50  wm-100 mx-auto ">
          <div className="card-body">
            <div className="d-flex flex-row justify-content-between align-items-center flex-wrap">
              <h5 className="card-title ">مشخصات کاربر</h5>
              <div className="d-flex flex-wrap gap-2">
                <Link
                  className={
                    "btn btn-light d-flex align-items-center justify-conteent-between gap-1"
                  }
                  to="/MyCoins"
                  state={location?.pathname}
                >
                  {" "}
                  سکه ها{" "}
                  <FontAwesomeIcon
                    icon={"coins"}
                    className="header-icon cursor-pointer"
                  />
                </Link>

                <Link
                  className={
                    "btn btn-light d-flex align-items-center justify-conteent-between gap-1"
                  }
                  to="/subsets"
                >
                  زیرمجموعه ها
                  <FontAwesomeIcon
                    icon={"user"}
                    className="header-icon cursor-pointer"
                  />
                </Link>
                <Link
                  className={
                    "btn btn-light d-flex align-items-center justify-conteent-between gap-1 "
                  }
                  to="/shopList"
                >
                  {" "}
                  خریدها
                  <FontAwesomeIcon
                    icon={"cart-shopping"}
                    className="header-icon cursor-pointer"
                  />
                </Link>
                <Link
                  className={
                    "btn btn-light d-flex align-items-center justify-conteent-between gap-1"
                  }
                  to="/userpayList"
                >
                  {" "}
                  پرداخت ها
                  <FontAwesomeIcon
                    icon="cash-register"
                    className="header-icon cursor-pointer"
                  />
                </Link>
              </div>
            </div>
            <hr />
            <div className="col-12">
              <div className="form-example-wrap mg-t-30">
                <div className="form-example-int form-horizental">
                  <div className="form-group ">
                    <PersonalInformation />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
      </div>
  );
};

export default () =><Helmet title='پروفایل'> <MainLayout children={<Profile />} /></Helmet>;

